import Modal from 'react-modal';
import React from 'react';
import './create-agent-modal.css';
import ComponentHelper from '../../../supers/ComponentHelper';
import InputField from '../../../components/input-field/InputField';
import RESTService from '../../../services/RESTService';
import Spinner from '../../../components/spinner/Spinner';

const connect = new RESTService();

class CreateAgentModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.setInitialData(props);
	}

	setInitialData = props => {
		this.data = {
			title: 'New Agent',
			agentName: '',
			saving: false,
			timeThreshold: '',
			errorMessage: null
		};
	};

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
			});
		}
	}

	isValidInput() {
		return this.data.agentName.length > 0;
	}

	onInputChange = evt => {
		let val = evt.target.value;
		if (evt.target.name === 'agentName') {
			val = val.replace(/[^\w-]+/g, '');
		}
		this.observe(() => {
			this.data[evt.target.name] = val;
		});
	};

	onCreate = () => {
		let { agentName, timeThreshold } = this.data;
		this.observe(() => {
			this.data.saving = true;
		});
		connect
			.createAgent({
				name: agentName,
				alertDelay: Number(timeThreshold)
			})
			.then(() => {
				this.props.onConfirm();
			})
			.catch(err => {
				this.observe(() => {
					this.data.saving = false;
					this.data.errorMessage = err.response.data;
				});
			});
	};

	render() {
		let { isOpen } = this.props;
		let { title, agentName, timeThreshold, saving, errorMessage } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				ariaHideApp={false}
				isOpen={isOpen}
				className="create-agent-modal animated zoomIn"
				overlayClassName="dialog-modal-overlay vbox hcenter vcenter"
			>
				<div className="modal-header">{title}</div>
				{saving && <Spinner height="200px" text="Saving..." />}
				{!saving && (
					<div className="modal-body">
						<InputField
							label="Agent Name"
							name="agentName"
							type="text"
							value={agentName}
							handleChange={this.onInputChange}
							placeholder="Enter a unique name"
							required
							autoFocus
						/>
						<InputField
							label="Time Threshold (seconds)"
							name="timeThreshold"
							type="number"
							value={timeThreshold}
							handleChange={this.onInputChange}
							placeholder="Time threshold"
						/>
					</div>
				)}
				{errorMessage && <div className="error-message">{errorMessage.message}</div>}
				{!saving && (
					<div className="btn-ctn">
						<button className="btn cancel-btn" onClick={this.props.onCancel}>
							Cancel
						</button>
						<button className="btn primary" onClick={this.onCreate} disabled={!this.isValidInput()}>
							Save
						</button>
					</div>
				)}
			</Modal>
		);
	}
}

export default CreateAgentModal;



// WEBPACK FOOTER //
// ./src/views/agents-setup/create-agent-modal/CreateAgentModal.js